import React from "react";
import moment from "moment";
import styles from "./ReservationDetails.module.scss";
import {useAppSelector} from "../../../store/store";
import {selectFetcherReservation} from "../../../store/fetcherSlice";

export const ReservationDetails: React.FunctionComponent<any> = () => {
  const reservation = useAppSelector(selectFetcherReservation);
  const createdReservationDate = reservation?.attributes?.created_at;
  const date = moment(createdReservationDate).format("YYYY-MM-DD");
  const hour = moment(createdReservationDate).format("h:mm A");

  return (
    <>
      <div className={styles.detailsItem}>
        <div className={styles.created}>Created</div>
        {createdReservationDate ? (
          <>
            <span className={styles.highlight}>{date}</span>
            <span className={styles.createdHour}>{hour}</span>
          </>
        ) : (
          <span className={styles.highlight}>No Information</span>
        )}
      </div>
      <div className={styles.detailsItem}>
        <div className={styles.reservationId}>Res ID</div>
        <span className={styles.highlight}>{reservation?.attributes?.legacy_reservation_id}</span>
      </div>
    </>
  );
};
